import React, { Component } from 'react';
import PropTypes from 'prop-types';
import handleKeyPress from '../../common/handleKeyPress';
import Button from '../../componentLibrary/Button';
import BlockLayouts from './BlockLayouts/BlockLayouts';
import ElementsCollection from './ElementsCollection/ElementsCollection';
import QuickBlocks from './QuickBlocks/QuickBlocks';
import imageSources from '../../constants/imageSources/imageSources';

export default class LeftPanelCollapsed extends Component {
    state = {
        openedMenu: null,
    };

    _handleMenuButtonClick = (option) => {
        const { openedMenu } = this.state;
        if (openedMenu !== option) {
            this.setState({ openedMenu: option });
        } else {
            this.setState({ openedMenu: false });
        }
    };

    render() {
        const { leftPanelCollapsed } = this.props;
        const { openedMenu } = this.state;
        const closeButton = (
            <div
                onClick={() => this.setState({ openedMenu: null })}
                onKeyDown={(e) => handleKeyPress(e, () => this.setState({ openedMenu: null }))}
                role="button"
                tabIndex={0}
                aria-label="close menu popup"
            >
                <i
                    className="material-icons"
                    style={{
                        fontSize: 20,
                        color: 'black',
                        position: 'absolute',
                        right: 10,
                        top: 12,
                        cursor: 'pointer',
                    }}
                    aria-hidden
                >
                    close
                </i>
            </div>
        );

        return (
            <div>
                <div style={{ width: 32, height: 32, padding: '10px 0', margin: '0 auto' }}>
                    <Button
                        type="simple"
                        width={32}
                        label="Block Layouts"
                        src={
                            openedMenu === 'layouts'
                                ? imageSources.COLLAPSED_ICONS.BLOCK_LAYOUTS.HIGHLIGHTED
                                : imageSources.COLLAPSED_ICONS.BLOCK_LAYOUTS.DEFAULT
                        }
                        cursor="pointer"
                        onClick={() => this._handleMenuButtonClick('layouts')}
                        hasTooltip={openedMenu !== 'layouts'}
                        tooltipPosition="right"
                    />
                </div>
                <div style={{ width: 32, height: 32, padding: '10px 0', margin: '0 auto' }}>
                    <Button
                        type="simple"
                        width={32}
                        label="Elements"
                        src={
                            openedMenu === 'elements'
                                ? imageSources.COLLAPSED_ICONS.ELEMENTS.HIGHLIGHTED
                                : imageSources.COLLAPSED_ICONS.ELEMENTS.DEFAULT
                        }
                        cursor="pointer"
                        onClick={() => this._handleMenuButtonClick('elements')}
                        hasTooltip={openedMenu !== 'elements'}
                        tooltipPosition="right"
                    />
                </div>
                <div style={{ width: 32, height: 32, padding: '10px 0', margin: '0 auto' }}>
                    <Button
                        type="simple"
                        width={32}
                        label="Quick Blocks"
                        src={
                            openedMenu === 'presets'
                                ? imageSources.COLLAPSED_ICONS.QUICK_BLOCKS.HIGHLIGHTED
                                : imageSources.COLLAPSED_ICONS.QUICK_BLOCKS.DEFAULT
                        }
                        cursor="pointer"
                        onClick={() => this._handleMenuButtonClick('presets')}
                        hasTooltip={openedMenu !== 'presets'}
                        tooltipPosition="right"
                    />
                </div>
                {leftPanelCollapsed && openedMenu === 'layouts' && (
                    <div style={{ position: 'absolute', left: 67, top: 3, zIndex: 3 }}>
                        <div
                            style={{
                                width: 180,
                                margin: '0 auto',
                                padding: 12,
                                height: 125,
                                backgroundColor: 'white',
                                boxShadow: '1px 1px 1px gray',
                            }}
                        >
                            <p style={{ fontSize: 12, fontWeight: 600, letterSpacing: 1, color: '#535454' }}>
                                BLOCK LAYOUTS
                            </p>
                            <BlockLayouts />
                        </div>
                        {closeButton}
                    </div>
                )}
                {leftPanelCollapsed && openedMenu === 'elements' && (
                    <div style={{ position: 'absolute', left: 67, top: 55, zIndex: 3 }}>
                        <div
                            style={{
                                width: 180,
                                height: 124,
                                padding: 12,
                                backgroundColor: 'white',
                                boxShadow: '1px 1px 1px gray',
                            }}
                        >
                            <p style={{ fontSize: 12, fontWeight: 600, letterSpacing: 1, color: '#535454' }}>
                                ELEMENTS
                            </p>
                            <ElementsCollection />
                        </div>
                        {closeButton}
                    </div>
                )}
                {leftPanelCollapsed && openedMenu === 'presets' && (
                    <div style={{ position: 'absolute', left: 67, top: 105, zIndex: 3 }}>
                        <div
                            style={{
                                width: 180,
                                height: 250,
                                padding: 12,
                                backgroundColor: 'white',
                                boxShadow: '1px 1px 1px gray',
                            }}
                        >
                            <p
                                style={{
                                    fontSize: 12,
                                    fontWeight: 600,
                                    letterSpacing: 1,
                                    color: '#535454',
                                    marginBottom: 5,
                                }}
                            >
                                QUICK BLOCKS
                            </p>
                            <QuickBlocks />
                        </div>
                        {closeButton}
                    </div>
                )}
            </div>
        );
    }
}

LeftPanelCollapsed.propTypes = {
    leftPanelCollapsed: PropTypes.bool.isRequired,
};
